document.addEventListener('DOMContentLoaded', function () {
  const search = instantsearch({
	indexName: 'THECIVIC', // Replace with your Algolia index name
	searchClient: algoliasearch('NRT0E8W0B1', '0718e692f7d1a09159d12b6cfd7b4ef9'),
	searchFunction: function(helper) {
	  if (helper.state.query === '') {
		helper.setQuery('').search();
		document.getElementById('hits').innerHTML = '';
		return;
	  }
	  helper.search();
	},
  });

  search.addWidgets([
	instantsearch.widgets.searchBox({
	  container: '#searchbox',
	  placeholder: 'Search for articles...',
	  showReset: true,
	  showSubmit: true,
	  showLoadingIndicator: true,
	}),
	instantsearch.widgets.hits({
	  container: '#hits',
	  templates: {
		item: `
		  <article>
			<h2><a href="{{url}}">{{_highlightResult.title.value}}</a></h2>
			<p>{{_snippetResult.excerpt.value}}</p>
		  </article>
		`,
		empty: 'No results found for "{{query}}"',
	  },
	}),
	instantsearch.widgets.pagination({
	  container: '#pagination',
	}),
  ]);

  search.start();

  // Modal functionality
  const openSearch = document.getElementById('open-search');
  const closeSearch = document.getElementById('close-search');
  const searchModal = document.getElementById('search-modal');

  openSearch.addEventListener('click', () => {
	searchModal.style.display = 'flex';
	document.querySelector('#searchbox input').focus();
  });

  closeSearch.addEventListener('click', () => {
	searchModal.style.display = 'none';
	search.helper.setQuery('').search(); // Clear search
  });
});